module.exports = __webpack_public_path__ + "static/media/icon-warning.d6cb6f2f.svg";